// LICENSE_CODE ZON
'use strict';

/*jslint browser:true, es6:true, node:true, react:true*/
var _excluded = ["tmpl", "on_click", "products_style", "navbar_style", "aff_style"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, Fragment, memo } from 'react';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import { Slider } from './slider.js';
import styles from './hola_tabs.module.less';
var Tab = /*#__PURE__*/memo(props => {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var cat = props.cat,
    is_active = props.is_active,
    set_active = props.set_active,
    c2name = props.c2name,
    c2icon = props.c2icon,
    c_icons = props.c_icons,
    icons_type = props.icons_type;
  var icon = c2icon[cat] || `ic-apps-${cat}`;
  var id = `${icon}${is_active ? '-active' : ''}`;
  var svg = c_icons[id];
  return /*#__PURE__*/React.createElement("div", {
    onClick: () => set_active(cat),
    className: cn(styles.tab_cat, {
      [styles.active]: is_active
    })
  }, svg, /*#__PURE__*/React.createElement("p", null, t(c2name[cat])));
});
var Tabs_header = props => {
  var cats = props.cats,
    active = props.active,
    set_active = props.set_active,
    ignore = props.ignore,
    c2name = props.c2name,
    c2icon = props.c2icon,
    c_icons = props.c_icons,
    icons_type = props.icons_type;
  var rendered_cats = cats.map(cat => {
    if (ignore && ignore.includes(cat)) return null;
    return /*#__PURE__*/React.createElement(Tab, {
      key: `svg-${cat}`,
      cat: cat,
      c2name: c2name,
      c2icon: c2icon,
      is_active: cat == active,
      set_active: set_active,
      icons_type: icons_type,
      c_icons: c_icons
    });
  });
  var on_scroll = progress => {
    if (progress < 1) {
      var active_index = Math.floor(progress * cats.length);
      set_active(cats[active_index]);
    }
  };
  return /*#__PURE__*/React.createElement(Slider, {
    className: styles.tab_cats,
    skip_slide: true,
    on_scroll: on_scroll
  }, rendered_cats);
};
var Hola_tabs_base = props => {
  var root_tag = props.root_tag,
    all = props.all,
    on_change = props.on_change,
    content = props.content,
    ignore = props.ignore,
    body = props.body,
    items = props.items,
    _props$c2name = props.c2name,
    c2name = _props$c2name === void 0 ? {} : _props$c2name,
    _props$c2icon = props.c2icon,
    c2icon = _props$c2icon === void 0 ? {} : _props$c2icon,
    _props$c_icons = props.c_icons,
    c_icons = _props$c_icons === void 0 ? {} : _props$c_icons,
    icons_type = props.icons_type,
    _props$cls = props.cls,
    cls = _props$cls === void 0 ? styles.hola_tabs : _props$cls,
    _props$cat_groups = props.cat_groups,
    cat_groups = _props$cat_groups === void 0 ? {} : _props$cat_groups;
  var cats = Object.keys(items);
  var Root = root_tag || 'ul';
  var Content_tag = content || Fragment;
  var init_cat = props.cat && cats.find(c => c == props.cat) || cats[0];
  var _useState = useState(init_cat),
    _useState2 = _slicedToArray(_useState, 2),
    active = _useState2[0],
    set_active = _useState2[1];
  var on_tab_click = new_active => {
    if (on_change) on_change(new_active);
    set_active(new_active);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: cls
  }, /*#__PURE__*/React.createElement(Tabs_header, {
    active: active,
    set_active: on_tab_click,
    cats: cats,
    ignore: ignore,
    c2name: c2name,
    c2icon: c2icon,
    c_icons: c_icons,
    icons_type: icons_type
  }), /*#__PURE__*/React.createElement(Content_tag, null, cats.map(cat => {
    if (ignore && ignore.includes(cat)) return null;
    var sections = [{
      root_props: typeof Root != 'string' ? {
        category: cat,
        category_name: c2name[cat]
      } : {},
      items: items[cat] || []
    }];
    var groups;
    if (groups = cat_groups[cat]) {
      sections = groups.map(group => ({
        root_props: {
          category: group.cat,
          category_name: group.name
        },
        items: items[group.cat] || []
      }));
    }
    return /*#__PURE__*/React.createElement(Fragment, {
      key: cat
    }, sections.map(s => /*#__PURE__*/React.createElement(Root, _extends({
      key: s.root_props.category
    }, s.root_props, {
      className: cn(styles.tab_items, (all || cat == active) && styles.active)
    }), body(s.items, s.root_props.category || cat))));
  })));
};
var Hola_tabs = props => {
  var tmpl = props.tmpl,
    on_click = props.on_click,
    products_style = props.products_style,
    navbar_style = props.navbar_style,
    aff_style = props.aff_style,
    other = _objectWithoutProperties(props, _excluded);
  var Tmpl = tmpl;
  var cls = cn(styles.hola_tabs, navbar_style && styles.navbar_style, aff_style && styles.aff_style, products_style && styles.products_style);
  return /*#__PURE__*/React.createElement(Hola_tabs_base, _extends({
    body: (items, cat) => /*#__PURE__*/React.createElement(Fragment, null, items.map((item, i) => {
      return /*#__PURE__*/React.createElement(Tmpl, {
        item: item,
        key: i,
        cls: cls,
        on_click: on_click && (ev => on_click(ev, item))
      });
    })),
    cls: cls
  }, other));
};
export { Hola_tabs, Hola_tabs_base };